import { useSnapshot } from 'valtio';
import { dismissBanner } from '../actions/maintenance-actions';
import MaintenanceStore from '../stores/MaintenanceStore';

export const useMaintenance = () => {
  const state = useSnapshot(MaintenanceStore);

  return {
    state,
    handleClose: dismissBanner,
  };
};
